module.exports = __webpack_public_path__ + "img/hero-bg-green.b3c5eb90.svg";